import {
  MONTHLY_BOOKKEEPING,
  PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING,
  PRO_MONTHLY_BOOKKEEPING,
  US_BOOKKEEPING_SUBSCRIPTION_PARENT,
} from "types/Models/services";
import { object, string } from "yup";

export const createServiceSchema = object({
  endDate: string().when("serviceActionType", {
    is: (val: string) =>
      [PRO_MONTHLY_BOOKKEEPING, MONTHLY_BOOKKEEPING].includes(val),
    then: string().notRequired(),
    otherwise: string().when("serviceActionType", {
      is: PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING,
      then: string().notRequired(),
      otherwise: string().when("serviceActionType", {
        is: US_BOOKKEEPING_SUBSCRIPTION_PARENT,
        then: string().notRequired(),
        otherwise: string().required("Please select end date"),
      }),
    }),
  }),
  startDate: string().when("serviceActionType", {
    is: PAY_AS_YOU_GO_ANNUAL_BOOKKEEPING,
    then: string().notRequired(),
    otherwise: string().required("Please select start date"),
  }),
});
